<template>
  <tutorial-layout
    title="Vue Store"
    :referenceLinks="referenceLinks"
    :youtubeLinks="youtubeLinks"
  >

    <p slot="overview">The store provides a way to access application level settings and configurations across components.</p>
    <div slot="benefits">
      <p>
      By now, you should be familiar with how to pass props down to child components as well as how to send changes back to parent components through the $emit function.
      Though useful, this pattern is sometimes not practical.  One scenario that might strain this method is the need to store user profile data ad use it across disparate components in the application.  For example,. a user date format.
      In the common scenario, the date format would have to be passed to every child component that might require it.  Each of the those child components might have an endless number of components and subcomponents that could have a possible use a date format.  
      You can quickly see how attribute management would get out of control.
      </p>
      <p>
      One solution is to use a globally available variable.
      While this would work the issue that arises is the need to have this property behave reactively to ensure that all formatted dates change when the 
      date format is altered by the user.
      This is where the Vue Store shines.  It provides the ability to have globally accessible variables while also ensuring that these variables are reactive. 
      </p>
    </div>

    <h2>Configuration</h2>
    <p>
      If you have ever implemented the Vue Store you know that it is not always straightforward. 
      Defining States, Getters, Setters and Actions can be time consuming and often times even confusing.  
      This framework implements some basic vue store functionality for variables as well as options for persistent storage without any code.
      Configure the store variable in your app.config.js as shown below to get started.
    </p>
    <p>
      <small>If this does not meet your needs, please reach out to the team for help on your specific situation.</small>
    </p>

<br />
<h3>Take a look at the configuration below.</h3>
<v-row>
  <v-col>
    
    <ul>
      <li>We have an attribute named <b>dateFormat</b>.  When this configuration is processed and the app-mixin added to your component this will be translated to the following reactive variable name:<br /><b>{namespace}_dateFormat</b></li>
      <li>The default value will be true in this instance.</li>
      <li>The value will be persistently stored in the browser sessionStorage. (clearing on browser restarts)</li>
    </ul>
    <code>
    <pre>
import BrowserStorage from "@/_util/storage-modes.browser-storage";
const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);
{
  ...
  store : {
    dateFormat : {
      default: "YYYY-MM-DD",
      storageMode : sessionStorage,
    },
    ...
  }
}</pre>
    </code>
  </v-col>
</v-row>

<h2>Component Implementation</h2>
<p>
Each app folder should have a mixin that programmatically adds each of the store variables to your local component.
</p>

<code><pre>
  ...
  import appConfig from "../mixins/app.config"
  ...

  export default {
    ...
    mixins: [appConfig],
    ...
    created()
    {
      //assuming the current namespace is myApp
      console.log("dateFormat => ", this.myApp_dateFormat);
    }
  }
</pre></code>

    <h3>That's it..</h3>
    <p>
        At this point you can use your global store variables like any other reactive property.
        You can create computeds and watchers as well as assign to the variables seamlessly.
    </p>

  </tutorial-layout>
</template>

<script>
import moment from "moment";

import uiView from "@/_mixins/ui-view-mixin";
import tutorialLayout from "../../components/tutorial-layout";
export default {
  name: "VueStore",
  mixins: [uiView],
  created() {},
  data() {
    return {
    };
  },
  components: { tutorialLayout },
  props: {},
  watch: {},
  computed: {
    referenceLinks() {
      return [
      ];
    },
    youtubeLinks() {
      return [
      ];
    },
  },
  methods: {},
};
</script>
<style lang="scss">
</style>
